import 'whatwg-fetch';

import * as constants from '../constants/actions';
import * as endpoint from '../constants/endpoints';
import * as api from '../constants/api';

import {parseJSON,isOk,authReq,userServiceAuth} from '../utils/request';
import {getGuestCart} from '../utils/auth';


/******************************
*******  Synchronous  *********
******************************/


// export function productSaveDiamondResults(diamonds) {
//  return {
//     type: constants.PRODUCT_SAVE_DIAMONDS,
//     diamonds
//   };
// }




/******************************
*******  Asynchronous  ********
******************************/





export function cartGuestCartId() {
  return dispatch => {
    let url = api.MAGENTO_API + endpoint.MAGENTO_GET_GUEST_CART;
    return fetch(url, {
      method: 'post',
      headers: api.HEADERS
    })
    .then(parseJSON)
    .then((resp) => {
      if(isOk(resp.status)) {
        return Promise.resolve(resp.data);
      } else {
        return Promise.reject(resp.data);
      }
    });
  }
}

export function cartGuestAddItem(sku, product_desc = '', price = 0) {
  return dispatch => {

    if(price > 0) {
      window.dataLayer = window.dataLayer || [];   
      window.dataLayer.push({      
        'event': 'add_to_cart',
        'value': parseFloat(price),
        'order_quantity': 1,
        'currency': 'USD',
        'product_id': sku,
      });
    }

    // let cartId = getGuestCart();
    let url = api.MAGENTO_API + endpoint.MAGENTO_ADD_TO_CART;
    let bodyData = {
      apikey: 'fji2a23sdfji4og54asdi3jfa23sd2',
      sku: sku,
      product_desc: product_desc
    };

    return fetch(url, {
      method: 'post',
      headers: api.HEADERS,
      body: JSON.stringify(bodyData)
    })
    .then(parseJSON)
    .then((resp) => {
      if(isOk(resp.status)) {
        return Promise.resolve(resp.data);
      } else {
        return Promise.reject(resp.data);
      }
    });
  }
}

export function cartAddMetalSize(sku, metalType, ringSize, metalBase, metalMod, price, productDesc) {
  return dispatch => {

    window.dataLayer = window.dataLayer || [];   
    window.dataLayer.push({      
      'event': 'add_to_cart',
      'value': parseFloat(price + metalMod),
      'order_quantity': 1,
      'currency': 'USD',
      'product_id': sku,
    });

    // let cartId = getGuestCart();
    let url = api.MAGENTO_API + endpoint.MAGENTO_ADD_METAL_SIZE;
    let bodyData = {
      apikey: 'fji2a23sdfji4og54asdi3jfa23sd2',
      sku: sku,
      metal_type: metalType,
      ring_size: ringSize,
      metal_base: metalBase,
      metal_mod: metalMod,
      base: price,
      product_desc: productDesc,
    };

    return fetch(url, {
      method: 'post',
      headers: api.HEADERS,
      body: JSON.stringify(bodyData)
    })
    .then(parseJSON)
    .then((resp) => {
      if(isOk(resp.status)) {
        return Promise.resolve(resp.data);
      } else {
        return Promise.reject(resp.data);
      }
    });
  }
}

export function cartAddEngagementRing(sku, metal_type, ring_size, metal_base, metal_mod, stock_no, shape, price, setting_desc, diamond_desc) {
  return dispatch => {

    window.dataLayer = window.dataLayer || [];   
    window.dataLayer.push({      
      'event': 'add_to_cart',
      'value': parseFloat(metal_mod + price),
      'order_quantity': 2,
      'currency': 'USD',
      'product_id': sku,  
    });

    // let cartId = getGuestCart();
    let url = api.MAGENTO_API + endpoint.MAGENTO_ADD_ENGAGEMENT;
    let bodyData = {
      apikey: 'fji2a23sdfji4og54asdi3jfa23sd2',
      sku: sku,
      metal_type: metal_type,
      ring_size: ring_size,
      metal_base: metal_base,
      metal_mod: metal_mod,
      stock_no: stock_no,
      shape: shape.toLowerCase().trim(),
      price: price,
      setting_desc: setting_desc,
      diamond_desc: diamond_desc,
    };

    return fetch(url, {
      method: 'post',
      headers: api.HEADERS,
      body: JSON.stringify(bodyData)
    })
    .then(parseJSON)
    .then((resp) => {
      if(isOk(resp.status)) {
        return Promise.resolve(resp.data);
      } else {
        return Promise.reject(resp.data);
      }
    });
  }
}


export function cartLoggedInItems() {
  return dispatch => {

    // let url = api.MAGENTO_API + endpoint.MAGENTO_LOGGED_IN_CART;
    let url = api.MAGENTO_API + endpoint.MAGENTO_CART_COUNT;

    return fetch(url, {
      method: 'get',
      headers: api.HEADERS,
    })
    .then(parseJSON)
    .then((resp) => {
      if(isOk(resp.status)) {
        return Promise.resolve(resp.data);
      } else {
        return Promise.reject(resp.data);
      }
    });
  }
}


export function cartAddDiamond(stockNo, price, shape, diamond_desc) {
  return dispatch => {

    window.dataLayer = window.dataLayer || [];   
    window.dataLayer.push({      
      'event': 'add_to_cart',
      'value': parseFloat(price),
      'order_quantity': 1,
      'currency': 'USD',
      'product_id': stockNo,
    });

    // let cartId = getGuestCart();
    let url = api.MAGENTO_API + endpoint.MAGENTO_ADD_DIAMOND;
    let bodyData = {
      apikey: 'fji2a23sdfji4og54asdi3jfa23sd2',
      stock_no: stockNo,
      shape: shape.toLowerCase().trim(),
      price: price,
      diamond_desc: diamond_desc,
    };

    return fetch(url, {
      method: 'post',
      headers: api.HEADERS,
      body: JSON.stringify(bodyData)
    })
    .then(parseJSON)
    .then((resp) => {
      if(isOk(resp.status)) {
        return Promise.resolve(resp.data);
      } else {
        return Promise.reject(resp.data);
      }
    });
  }
}


export function cartAddDiamondJewelry(sku, carat_mod, diamond_desc) {
  return dispatch => {

    window.dataLayer = window.dataLayer || [];   
    window.dataLayer.push({      
      'event': 'add_to_cart',
      'value': parseFloat(carat_mod),
      'order_quantity': 1,
      'currency': 'USD',
      'product_id': sku,
    });

    // let cartId = getGuestCart();
    let url = api.MAGENTO_API + endpoint.MAGENTO_ADD_DIAMOND_JEWELRY;
    let bodyData = {
      apikey: 'fji2a23sdfji4og54asdi3jfa23sd2',
      sku: sku,
      carat_mod: carat_mod,
      diamond_desc: diamond_desc
    };

    return fetch(url, {
      method: 'post',
      headers: api.HEADERS,
      body: JSON.stringify(bodyData)
    })
    .then(parseJSON)
    .then((resp) => {
      if(isOk(resp.status)) {
        return Promise.resolve(resp.data);
      } else {
        return Promise.reject(resp.data);
      }
    });
  }
}





// WEBPACK FOOTER //
// ./src/actions/cart.jsx